import { jsx as _jsx } from "react/jsx-runtime";
import { ModalContext } from '#pplx/frontend/aether/modals/context/ModalContext.js';
import { getComponentName } from '#pplx/frontend/aether/modals/internal/getComponentName.js';
import { useModalStore } from '#pplx/frontend/aether/modals/store/useModalStore.js';
import { memo, useMemo } from 'react';
const selector = (store) => ({
    add: store.addModal,
    update: store.updateModal,
    reset: store.resetModals,
});
export const ModalStateProvider = memo(function ModalStateProvider({ children, logger }) {
    const { add, update, reset } = useModalStore(selector);
    const { warn } = logger;
    const openModal = useMemo(() => {
        return (modal, props, options, internal) => {
            if (options?.replace === true) {
                reset();
            }
            const modalState = add({ modal, props, inheritScope: internal?.inheritScope });
            const updateModal = (props) => {
                const result = update({ id: modalState.id, props });
                if (result === null) {
                    warn('Attempted to update a modal that does not exist', {
                        id: modalState.id,
                        name: getComponentName(modalState.modal),
                    });
                }
            };
            const closeModal = () => {
                const result = update({ id: modalState.id, status: 'exiting' });
                if (result === null) {
                    warn('Attempted to close a modal that does not exist', {
                        id: modalState.id,
                        name: getComponentName(modalState.modal),
                    });
                }
            };
            return { updateModal, closeModal };
        };
    }, [add, reset, update, warn]);
    const contextValue = useMemo(() => ({ openModal }), [openModal]);
    return _jsx(ModalContext.Provider, { value: contextValue, children: children });
});
//# sourceMappingURL=ModalStateProvider.js.map